export default {"src":"/_next/static/media/ic-search.f1bf1360.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};